// extracted by mini-css-extract-plugin
module.exports = {"default":"spacer_default__3OqVI","medium":"spacer_medium__I5w_S"};